import {lazy} from "react";

export const TrackableObjectsSingleVoyagesLazy = lazy(() => import('./TrackableObjectsSingleVoyages'))
